import React, { useEffect, useState } from 'react';
import './Simulation.css';
import { useModel } from '../context/ModelContext';
import { Scenario } from '../types/model';
import ScenarioEditor from './ScenarioEditor';
import ScenarioManager from './ScenarioManager';
import ScenarioVisualization from './ScenarioVisualization';
import ModelComparison from './ModelComparison';
import BaselinePanel from './BaselinePanel';
import { takeScenarioRequest } from '../utils/scenarioNavigation';

const Dashboard: React.FC = () => {
  const { scenarios, getSelectedScenarios, clearError, error } = useModel();
  const [activeTab, setActiveTab] = useState<'baseline' | 'scenarios'>('baseline');
  const [experimentsVisited, setExperimentsVisited] = useState(false);
  const [draft, setDraft] = useState<{ version: number; scenario: Scenario | null }>({version: 0, scenario: null});
  const selected = getSelectedScenarios();
  const mixed = new Set(selected.map(s => `${s.framework}/${s.dataset}`)).size > 1;
  const first = selected[0];
  const newDraft = (scenario: Scenario | null = null) => setDraft(previous => ({ version: previous.version + 1, scenario }));
  useEffect(() => {
    const open = () => {
      const request = takeScenarioRequest();
      if (!request) return;
      if (request.scenario) newDraft(request.scenario);
      setExperimentsVisited(true);
      setActiveTab('scenarios');
    };
    open();
    window.addEventListener('research-scenario', open);
    return () => window.removeEventListener('research-scenario', open);
  }, []);
  return <div className="simulation-workspace">
    {error && <p role="alert">{error} <button onClick={clearError}>Dismiss</button></p>}
    <div className="simulation-tabs" role="group" aria-label="Simulation view">
      <button aria-pressed={activeTab === 'baseline'} onClick={() => setActiveTab('baseline')}>Explore baseline</button>
      <button aria-pressed={activeTab === 'scenarios'} onClick={() => { setExperimentsVisited(true); setActiveTab('scenarios'); }}>Policy experiments</button>
    </div>
    <div hidden={activeTab !== 'baseline'}><BaselinePanel /></div>
    <div hidden={activeTab !== 'scenarios'}>
      {experimentsVisited && <div className="experiment-workspace">
        <ScenarioEditor key={draft.version} isOpen onClose={() => newDraft()} editingScenario={draft.scenario} />
        <div className="experiment-results">
          <div className="scenario-workbench"><ScenarioManager onEdit={scenario => newDraft(scenario)} /></div>
          {!!selected.length ? <section className="results-surface" aria-label="Simulation results">
            {mixed ? <ModelComparison scenarios={selected} /> : <ScenarioVisualization key={`${first.framework}/${first.dataset}`} scenarios={selected} framework={first.framework} dataset={first.dataset} />}
          </section> : <section className="experiment-empty"><h2>{scenarios.some(s => s.status === 'solving') ? 'Scenario running' : 'Results'}</h2>
            <p>{scenarios.some(s => s.status === 'solved') ? 'Select a completed run above to view or compare its results.' : 'Run a scenario to view its results.'}</p>
          </section>}
        </div>
      </div>}
    </div>
  </div>;
};
export default Dashboard;
